import React from 'react';
import ReactDOM from 'react-dom';
import NewHomePage from './NewHomePage';

export const renderNewHomePage = () => {
  ReactDOM.render(<NewHomePage />, document.getElementById('homepage-concept-2'));
};
